<template>
	<div class="project-choose-volunteers-read-only-view" style="page-break-inside: auto; margin: 10px 0 10px 0">
		<egranty-section-divider
			text="Wolontariusze"
			icon="people"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<v-card style="padding: 10px 0 10px 0">
			<v-form ref="form">
				<div v-if="data.length === 0" class="ma-3" style="page-break-inside: avoid">
					Udział wolontariuszy nie jest przewidziany.
				</div>

				<div v-for="(v, index) in data" :key="index" class="mt-3 ml-3 mr-3" style="page-break-inside: avoid">
					<v-layout row>
						<h4 class="mr-2">{{1+index}}.</h4>
						<div>
							<strong>{{v.name}} {{v.surname}}</strong>&nbsp;&nbsp;({{v.email}})
						</div>
					</v-layout>
					<v-layout row mt-2 ml-4>
						<div>
							<strong>Dane teleadresowe:</strong> {{v.address.street}}
							{{v.address.building}}
							{{v.address.apartment === '' || v.address.apartment === null ? '' : '/'
								+ v.address.apartment}}, {{v.address.postalCode}}
							{{v.address.city}}{{v.phoneNumber === undefined ? "" : ", tel. " + v.phoneNumber}}
						</div>
					</v-layout>
					<v-layout row mt-2 ml-4>
						<div>
							<strong>Liczba dni wolontariatu:</strong> {{getTotalDaysAbroad(v)}}
						</div>
					</v-layout>
					<v-layout mt-2 ml-4>
						<div>
							<strong>Okresy wolontariatu:</strong>
						</div>
						<ul>
							<li class="ml-4" v-for="(vt, termIndex) in v.volunteeringTerms" :key="termIndex">
								{{termIndex + 1}}. {{vt.volunteeringStartDate}} - {{vt.volunteeringEndDate}}
							</li>
						</ul>
					</v-layout>
				</div>
			</v-form>

			<div v-if="data.length !== 0" :class='{notChecked: !globalInitiative.isGlobal}'>
				<v-layout row mt-4 ml-4>
					<div>
						<strong>W projekcie jest realizowana inicjatywa edukacyjna:</strong>
						{{globalInitiative.isGlobal ? 'TAK' : 'NIE'}}
					</div>
				</v-layout>
			</div>

			<div v-if="globalInitiative.isGlobal">
				<v-layout mt-4 ml-4>
					<div><strong>Opis inicjatywy edukacyjnej:</strong>
						<div class="mt-2 ml-4 mr-5 mb-2" style="white-space: pre-line">
							{{globalInitiative.description}}
						</div>
					</div>
				</v-layout>
			</div>
		</v-card>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "ProjectChooseVolunteersReadOnlyView",
		components: {
			EgrantySectionDivider,
		},

		data () {
			return {
				volunteer: {
					address: {
						apartment: "",
						building: "",
						city: "",
						postalCode: "",
						street: ""
					},
					name: "",
					surname: "",
					email: "",
					volunteerCode: "",
					volunteeringTerms: [],
					volunteeringStartDate: "",
					volunteeringEndDate: ""
				},
				globalInitiative: {
					isGlobal: false,
					description: ''
				},
				code: "",
				startDate: "",
				endDate: "",
				data: [],
				error: ""
			};
		},

		methods: {
			uniqueVolunteer (code) {
				return !this.data.map(volunteer => volunteer.volunteerCode).includes(code);
			},

			getTotalDaysAbroad (volunteer) {
				let totalDays = 0;
				volunteer.volunteeringTerms.forEach(volunteer => {
					if (volunteer.volunteeringStartDate !== null && volunteer.volunteeringEndDate !== null) {
						totalDays += 1 + this.getDayDifference(new Date(volunteer.volunteeringStartDate), new Date(volunteer.volunteeringEndDate));
					}
				});
				return totalDays;
			},

			getDayDifference (dt1, dt2) {
				return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
			},

			getFormattedDate (date) {
				if (date !== null && date !== undefined) {
					let year = date[0];
					let month = date[1] < 10 ? '0' + date[1] : date[1];
					let day = date[2] < 10 ? '0' + date[2] : date[2];
					return year + "-" + month + "-" + day;
				} else return "";
			},

			//zwraca true gdy terminy się nie przepletają lub false w przeciwnym przypadku
			areVolunteeringTermsRangesIndependent (volunteeringTerm1, volunteeringTerm2) {
				return !((volunteeringTerm1.volunteeringStartDate >= volunteeringTerm2.volunteeringStartDate &&
					volunteeringTerm1.volunteeringStartDate <= volunteeringTerm2.volunteeringEndDate) ||
					(volunteeringTerm1.volunteeringEndDate >= volunteeringTerm2.volunteeringStartDate &&
					volunteeringTerm1.volunteeringEndDate <= volunteeringTerm2.volunteeringEndDate));
			},

			getMinStartDate () {
				return this.moduleStartDate;
			},

			getMaxStartDate (volunteeringTerm) {
				return volunteeringTerm.volunteeringEndDate !== null ? volunteeringTerm.volunteeringEndDate : this.moduleEndDate;
			},

			getMinEndDay (volunteeringTerm) {
				return volunteeringTerm.volunteeringStartDate !== null ? volunteeringTerm.volunteeringStartDate : this.moduleStartDate;
			},

			getMaxEndDate () {
				return this.moduleEndDate;
			},

			sync () {
				this.error = "";
				this.$emit("input", this.data);
			},

		},

		watch: {
			value: {
				immediate: true,
				handler (val) {
					if (val === undefined || val === null) {
						val = [];
					}
					this.data = val;
					this.data.forEach(item => {
						if (typeof item.volunteeringStartDate !== 'string')
							item.volunteeringStartDate = this.getFormattedDate(item.volunteeringStartDate);
						if (typeof item.volunteeringEndDate !== 'string')
							item.volunteeringEndDate = this.getFormattedDate(item.volunteeringEndDate);
					});
				},
			},

			globalInit: {
				immediate: true,
				handler (val) {
					this.globalInitiative.isGlobal = val;
				},
			},

			globalInitDescription: {
				immediate: true,
				handler (val) {
					this.globalInitiative.description = val;
				},
			}
		},

		props: {
			moduleStartDate: {
				default: undefined
			},
			moduleEndDate: {
				default: undefined
			},
			numberOfModules: {
				default: 0
			},
			value: Array,
			globalInit: Boolean,
			globalInitDescription: String,
			volunteersRequired: Boolean,
			volunteerLimit: Number,
			minDaysAbroad: Number,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};

</script>

<style scoped>
	@media print {
		.project-choose-volunteers-read-only-view {
			border: 1px solid grey;
		}

		.v-card {
			border: none
		}
	}
</style>
